<template>
    <div class="h-100 d-flex flex-column">
        <div class="sidebar-top">
            <div class="sidebar-item-no-border border-none">
                <mode-selector></mode-selector>
            </div>
            <div class="sidebar-item">
                <upload-box
                    v-if="
                        creatorStudio.settings.activeTool === 'similiarimage' &&
                        creatorStudio.settings.similiarImageJob.apiJob === null
                    "
                ></upload-box>
                <preview-similiar-image
                    v-if="
                        creatorStudio.settings.activeTool === 'similiarimage' &&
                        creatorStudio.settings.similiarImageJob.apiJob !== null
                    "
                ></preview-similiar-image>

                <div
                    class="continue-btn"
                    @click="toggleFineTune"
                    v-if="creatorStudio.settings.activeTool === 'similiarimage'"
                >
                    <div class="continue-btn-text">
                        <i class="far fa-cog"></i>
                        Fine-Tune Details
                    </div>
                    <div>
                        <i v-if="fineTune === false" class="far fa-chevron-down"></i>
                        <i v-if="fineTune === true" class="far fa-chevron-up"></i>
                    </div>
                </div>

                <prompt
                    :isRowDynamic="true"
                    v-if="creatorStudio.settings.activeTool === 'texttoimage' || fineTune === true"
                ></prompt>
                <div
                    class="d-flex gap-10 justify-content-between"
                    v-if="creatorStudio.settings.activeTool === 'texttoimage' || fineTune === true"
                >
                    <prompt-editor-nav-btn></prompt-editor-nav-btn>
                    <surprise-me-button v-if="creatorStudio.settings.activeTool === 'texttoimage'"></surprise-me-button>
                </div>
            </div>
            <div class="sidebar-item">
                <styles></styles>
            </div>
            <div class="sidebar-item" v-if="this.creatorStudio.settings.prompt_modifier.length > 0">
                <prompt-modifier></prompt-modifier>
            </div>
            <div class="sidebar-item">
                <number-of-images></number-of-images>
            </div>
            <div class="sidebar-item">
                <aspect-ratio></aspect-ratio>
            </div>
            <div class="sidebar-item">
                <advanced-settings-btn></advanced-settings-btn>
            </div>
            <div class="sidebar-item">
                <credit-cost></credit-cost>
            </div>
        </div>
        <div v-if="!creatorStudio.isMobile" class="sidebar-bot btn-box">
            <generate-btn></generate-btn>
        </div>
    </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import Prompt from '../Settings/Prompt.vue';
import GenerateBtn from '../Settings/GenerateBtn.vue';
import AdvancedSettingsBtn from '../Settings/AdvancedSettingsBtn.vue';
import Styles from '../Settings/Styles.vue';
import AspectRatio from '../Settings/AspectRatio.vue';
import CreditCost from '../Settings/CreditCost.vue';
import PromptModifier from '../Settings/PromptModifier.vue';
import NumberOfImages from '../Settings/NumberOfImages.vue';
import PromptEditorNavBtn from '../Settings/Elements/PromptEditorNavBtn.vue';
import SurpriseMeButton from '../Settings/Elements/SurpriseMeButton.vue';
import ModeSelector from '../Settings/ModeSelector.vue';
import UploadBox from '../Settings/UploadBox.vue';
import currentJob from '../../mixins/current_job.mixin';
import PreviewSimiliarImage from '../Settings/PreviewSimiliarImage.vue';

export default {
    name: 'SidebarLeftSettings',
    props: {},
    components: {
        PreviewSimiliarImage,
        UploadBox,
        ModeSelector,
        Prompt,
        GenerateBtn,
        AspectRatio,
        Styles,
        AdvancedSettingsBtn,
        CreditCost,
        PromptModifier,
        NumberOfImages,
        PromptEditorNavBtn,
        SurpriseMeButton,
    },
    mixins: [store, currentJob],
    data() {
        return {
            fineTune: false,
        };
    },
    mounted: function () {},
    created: function () {},
    methods: {
        toggleFineTune() {
            this.fineTune = !this.fineTune;
        },
    },
    computed: {},
};
</script>
<style lang="scss">
.gap-10 {
    gap: 10px;
}
</style>
